<script setup lang="ts">
const items = [
  {
    title: 'Cashflow Macet',
    description:
      'Dana COD yang belum cair bikin arus kas tersendat dan bisnis sulit berkembang.',
    icon: 'material-symbols:credit-card-off'
  },
  {
    title: 'Stok Barang Nggak Muter',
    description:
      'Uang tertahan = stok nggak bisa diputar buat produksi atau restock barang.',
    icon: 'material-symbols:open-in-new-off'
  },
  {
    title: 'Promosi Tertunda',
    description:
      'Tanpa modal segar, campaign iklan harus berhenti padahal peluang penjualan lagi tinggi.',
    icon: 'ic:outline-back-hand'
  },
  {
    title: 'Pertumbuhan Bisnis Melambat',
    description:
      'Setiap hari dana tertahan artinya kehilangan momentum untuk tumbuh lebih cepat.',
    icon: 'material-symbols:trending-down'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiSectionWrapper
    image-class="lg:order-first"
    title="Pernah Ngerasa Uang COD Lama Banget Cairnya?"
    description="Banyak pebisnis online kesulitan muter modal karena dana COD tertahan terlalu lama."
    hero-image="/images/cod-cair-cepat-banner-2.webp"
    class="py-12"
  >
    <template #action>
      <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="flex items-start gap-3"
        >
          <div
            class="p-2 rounded-full bg-primary-container flex-none text-primary"
          >
            <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
          </div>
          <div class="flex-1 flex flex-col gap-2">
            <p class="text-sm lg:text-xl font-bold lg:font-semibold">
              {{ item.title }}
            </p>
            <p class="text-sm lg:text-base text-outline">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </UiSectionWrapper>
</template>
